/* KI-Hinweis-Badge: oeffnet beim Klick einen Hinweis-Layer am unteren Rand,
   inklusive abgedunkeltem Hintergrund.

   Alle kritischen Styles werden hier direkt am Element gesetzt (nicht ueber
   die CSS-Datei). Grund: faellt das Stylesheet aus irgendeinem Grund aus,
   waere der Backdrop ein unsichtbares, nicht klickbares Div - die
   Verdunkelung und das Schliessen per Klick ins Leere wuerden stillschweigend
   nicht funktionieren. Inline gesetzt ist beides garantiert.

   Der Layer wird erst beim ersten Klick erzeugt und danach wiederverwendet,
   damit pro Seite nur ein einziges Element existiert - egal wie viele
   Produktkarten es gibt. */
(function () {
  if (window.__erKiBadgeInit) return;
  window.__erKiBadgeInit = true;

  var TITLE = 'Mit KI generiert';
  var TEXT = 'Dieses Bild wurde ganz oder teilweise mithilfe künstlicher Intelligenz erstellt.';

  var backdrop = null;
  var sheet = null;
  var closeTimer = null;

  function isDesktop() {
    return window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
  }

  function hiddenTransform() {
    return isDesktop() ? 'translate(-50%, calc(100% + 40px))' : 'translateY(100%)';
  }

  function shownTransform() {
    return isDesktop() ? 'translate(-50%, 0)' : 'translateY(0)';
  }

  function layoutSheet() {
    if (isDesktop()) {
      sheet.style.left = '50%';
      sheet.style.right = 'auto';
      sheet.style.bottom = '20px';
      sheet.style.width = 'calc(100% - 40px)';
      sheet.style.maxWidth = '460px';
      sheet.style.borderRadius = '14px';
    } else {
      sheet.style.left = '0';
      sheet.style.right = '0';
      sheet.style.bottom = '0';
      sheet.style.width = 'auto';
      sheet.style.maxWidth = 'none';
      sheet.style.borderRadius = '14px 14px 0 0';
    }
  }

  function build() {
    backdrop = document.createElement('div');
    backdrop.className = 'ki-sheet__backdrop';
    /* Bewusst OHNE Opacity-Animation und OHNE hidden-Attribut:
       Der Backdrop reagierte nachweislich auf Klicks, wurde aber nicht
       gezeichnet - ein reines Paint-Problem. Der einzige Unterschied zum
       funktionierenden Layer war die Animation von opacity 0 -> 1.
       Jetzt ist die Flaeche von Anfang an deckend eingefaerbt und wird
       nur ueber display ein-/ausgeblendet. Inline-display schlaegt jede
       CSS-Regel ohne !important, da kann nichts mehr dazwischenfunken.

       Offsets UND width/height gemeinsam: deckt jede Browser-Variante ab. */
    backdrop.style.cssText = [
      'display:none',
      'position:fixed',
      'top:0',
      'left:0',
      'right:0',
      'bottom:0',
      'width:100%',
      'height:100%',
      'min-height:100vh',
      'background:rgba(0,0,0,0.55)',
      'z-index:2147483000',
      'cursor:pointer',
      '-webkit-tap-highlight-color:transparent'
    ].join(';');

    sheet = document.createElement('div');
    sheet.className = 'ki-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', TITLE);
    sheet.style.cssText = [
      'position:fixed',
      'z-index:2147483001',
      'background:#111111',
      'color:#ffffff',
      'box-shadow:0 -2px 24px rgba(0,0,0,0.45)',
      'transition:transform 0.25s ease',
      'font-family:inherit',
      'text-align:left',
      'padding-bottom:env(safe-area-inset-bottom, 0px)'
    ].join(';');
    sheet.hidden = true;

    var head = document.createElement('div');
    head.className = 'ki-sheet__head';
    head.style.cssText = [
      'display:flex',
      'align-items:center',
      'justify-content:space-between',
      'gap:16px',
      'padding:18px 20px',
      'border-bottom:1px solid rgba(255,255,255,0.18)'
    ].join(';');

    var title = document.createElement('h2');
    title.className = 'ki-sheet__title';
    title.textContent = TITLE;
    title.style.cssText = [
      'margin:0',
      'font-size:19px',
      'font-weight:600',
      'line-height:1.2',
      'letter-spacing:0',
      'color:#ffffff',
      'text-transform:none'
    ].join(';');

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ki-sheet__close';
    closeBtn.setAttribute('aria-label', 'Schließen');
    closeBtn.style.cssText = [
      'flex:0 0 auto',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'width:40px',
      'height:40px',
      'padding:0',
      'margin:-8px -8px -8px 0',
      'border:0',
      'outline:none',
      'background:none',
      'box-shadow:none',
      'color:#ffffff',
      'cursor:pointer',
      'min-width:0',
      'min-height:0',
      '-webkit-appearance:none',
      'appearance:none',
      '-webkit-tap-highlight-color:transparent'
    ].join(';');
    closeBtn.innerHTML =
      '<svg viewBox="0 0 18 18" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" style="display:block">' +
      '<path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>' +
      '</svg>';

    head.appendChild(title);
    head.appendChild(closeBtn);

    var body = document.createElement('p');
    body.className = 'ki-sheet__body';
    body.textContent = TEXT;
    body.style.cssText = [
      'margin:0',
      'padding:20px',
      'font-size:16px',
      'line-height:1.45',
      'color:#ffffff',
      'text-transform:none'
    ].join(';');

    sheet.appendChild(head);
    sheet.appendChild(body);

    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);

    layoutSheet();
    sheet.style.transform = hiddenTransform();

    closeBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      close();
    });

    /* Klick auf die abgedunkelte Flaeche schliesst den Layer. */
    backdrop.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      close();
    });

    /* Klick INNERHALB des Layers darf nicht bis zum Backdrop durchschlagen. */
    sheet.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }

  function open() {
    if (!sheet) build();

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    layoutSheet();

    backdrop.style.display = 'block';
    sheet.hidden = false;
    sheet.style.transform = hiddenTransform();

    // Reflow erzwingen, damit der Slide-in wirklich animiert wird.
    void sheet.offsetWidth;

    sheet.style.transform = shownTransform();

    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    if (!sheet || sheet.hidden) return;

    sheet.style.transform = hiddenTransform();

    document.removeEventListener('keydown', onKeydown);

    closeTimer = window.setTimeout(function () {
      sheet.hidden = true;
      backdrop.style.display = 'none';
      closeTimer = null;
    }, 280);
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') close();
  }

  /* Capture-Phase: der Klick wird abgefangen, BEVOR der Karten-Link ihn
     bekommt. Sonst wuerde statt des Hinweises das Produkt geoeffnet. */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var badge = target.closest('.ki-badge');
      if (badge) {
        event.preventDefault();
        event.stopPropagation();

        /* Kein Fokus auf dem Badge behalten - sonst bliebe nach dem Schliessen
           ein sichtbarer Rahmen auf dem Bild stehen. */
        if (badge.blur) badge.blur();

        open();
        return;
      }

      /* Sicherheitsnetz: Layer ist offen und es wurde irgendwo ausserhalb
         geklickt -> schliessen. Greift auch dann, wenn der Backdrop selbst
         wider Erwarten keine klickbare Flaeche haette. */
      if (sheet && !sheet.hidden && !target.closest('.ki-sheet')) {
        event.preventDefault();
        event.stopPropagation();
        close();
      }
    },
    true
  );

  /* --- KI-Badge ueber ganzen Sections ----------------------------------
     Sections sind keine Produkte und haben deshalb kein Metafeld, ueber
     das sich ein Badge einbauen liesse. Statt jede Section-Datei
     anzufassen, wird der Button hier zur Laufzeit in den jeweiligen
     Wrapper gehaengt - Klick, Hinweis-Layer und Styling teilen sich
     damit denselben Code wie das Badge auf den Produktkarten. Groesse
     und Deckkraft kommen aus den CSS-Variablen, die
     snippets/ki-badge-global.liquid aus den Theme-Einstellungen
     schreibt; die Position steht in assets/collection-badge.css.

     Neue Stelle nachruesten: Eintrag in der Liste unten ergaenzen.
     "top: true" setzt das Badge oben rechts statt unten rechts.

     ACHTUNG bei Image-Banner-Sections: die Section rendert
     id="Banner-{{ section.id }}", und section.id ist bei einer
     JSON-Vorlage NICHT der Schluessel aus der Datei, sondern
     "template--<template-id>__<schluessel>". Der Praefix ist pro Shop
     verschieden, deshalb wird hier nur auf das Ende des id-Attributs
     geprueft - das bleibt stabil. */
  var BADGE_HOSTS = [
    /* GSAP-Pinned-Scroll auf der Startseite */
    { selector: '.racing-wrapper', top: false },
    /* Titelbild /pages/for-riders */
    { selector: '[id^="Banner-"][id$="image_banner_WzcgDi"]', top: true },
    /* Titelbild /pages/for-drivers */
    { selector: '[id^="Banner-"][id$="image_banner_eVkUhY"]', top: true }
  ];

  function paintSectionBadges() {
    for (var h = 0; h < BADGE_HOSTS.length; h++) {
      var host = BADGE_HOSTS[h];
      var targets = document.querySelectorAll(host.selector);

      for (var i = 0; i < targets.length; i++) {
        if (targets[i].querySelector('.ki-badge--corner')) continue;

        /* Bezugspunkt fuer die absolute Positionierung sicherstellen. */
        targets[i].classList.add('ki-badge-host');

        var badge = document.createElement('button');
        badge.type = 'button';
        badge.className = 'ki-badge ki-badge--corner' + (host.top ? ' ki-badge--corner-top' : '');
        badge.setAttribute('aria-label', 'Hinweis: Mit KI generiert');
        targets[i].appendChild(badge);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintSectionBadges);
  } else {
    paintSectionBadges();
  }

  /* Theme-Editor: Section wird neu gerendert -> Badge neu setzen. */
  document.addEventListener('shopify:section:load', paintSectionBadges);

  window.addEventListener('resize', function () {
    if (sheet && !sheet.hidden) {
      layoutSheet();
      sheet.style.transform = shownTransform();
    }
  });
})();
